/// The issues of one cash desk session's payout reconcile, from the entries
/// of the session transactions endpoint. An issue is a wrong transaction
/// ( ticket missing, amount mismatch, not captured ). The ones with a
/// registered ( DL ) side that is not paid out yet take a payout action -
/// go to pocket or transfer - and count as reviewed once they have one; a
/// not captured one has nothing to act on and stays pending until the
/// session reconciles.
class PaymentSessionIssues
{
    static readonly issue_statuses = [ "missingDL", "missingVenue", "amountMismatch" ];

    issues = 0;
    reviewed = 0;
    /// The issues that can take an action and have none yet
    undecided = 0;

    get pending() : number { return this.issues - this.reviewed; }

    static fromEntries( entries:any[] ) : PaymentSessionIssues {
        let summary = new PaymentSessionIssues();
        for (let entry of entries ?? []) {
            if (!PaymentSessionIssues.isIssue( entry )) continue;
            summary.issues++;
            if (PaymentSessionIssues.isDecided( entry )) summary.reviewed++;
            else if (PaymentSessionIssues.isActionable( entry )) summary.undecided++;
        }
        return summary;
    }

    static isIssue( entry:any ) : boolean {
        return PaymentSessionIssues.issue_statuses.indexOf( entry["status"] ) >= 0;
    }

    /// A wrong transaction with a registered side not paid out yet: its
    /// payout action can be set ( or changed ) from the review window.
    static isActionable( entry:any ) : boolean {
        let status = entry["status"];
        let dl_status = entry["dlStatus"] ?? -1;
        return entry["dlTransactionID"] != null
            && ( dl_status == 0 || dl_status == 2 || dl_status == 3 )
            && ( status == "missingVenue" || status == "amountMismatch" );
    }

    /// Pocketed ( 2 ) or accepted into the payout ( 3 )
    static isDecided( entry:any ) : boolean {
        let dl_status = entry["dlStatus"] ?? -1;
        return PaymentSessionIssues.isActionable( entry ) && ( dl_status == 2 || dl_status == 3 );
    }
}
